import { Host, h } from "@stencil/core";
let id = 0;
export class CoreRadioButton {
    constructor() {
        this.radioButtonId = `radio-button-${++id}`;
        this.handleCheck = () => {
            if (this.disabled || this.checked)
                return;
            this.checked = !this.checked;
            this.coreRadioButtonChange.emit(this.checked);
        };
        this.handleKeyDown = (event) => {
            if (this.disabled)
                return;
            if (event.key === 'Enter' || event.key === ' ') {
                this.handleCheck();
            }
        };
        this.renderLabel = () => {
            return (h("label", { class: "radio-button-label typography-body-medium-regular", id: `${this.radioButtonId}-label`, onClick: this.handleCheck }, this.label));
        };
        this.renderDescription = () => {
            return h("span", { class: "radio-button-description typography-body-small-regular" }, this.description);
        };
        this.renderInfos = () => {
            return (h("div", { class: "infos-box" }, this.renderLabel(), this.description && this.renderDescription()));
        };
        this.label = undefined;
        this.description = undefined;
        this.format = 'right';
        this.checked = false;
        this.disabled = false;
    }
    render() {
        return (h(Host, { key: '11da84885828eef21493f17850332a04f881276b' }, h("div", { key: 'ed5d457d857da8e5b06330d7c589044d24c1aacd', class: `core-radio-button ${this.disabled ? 'radio-button--disabled' : ''} ${this.checked ? 'radio-button--checked' : ''}` }, this.format === 'left' && this.renderInfos(), h("div", { key: 'ca9efc105332a56c55b779d6435c510e385170f4', class: "radio-button-wrapper" }, h("span", { key: 'ff1b1cdae18e5ac0a02efea3a6d0bb789f833585', role: "radio", class: "radio-button-box", tabindex: this.disabled ? -1 : 0, onKeyDown: this.handleKeyDown, onClick: this.handleCheck, "aria-label": this.format === 'hidden' ? this.label : null, "aria-labelledby": `${this.radioButtonId}-label`, "aria-checked": `${this.checked}`, "aria-disabled": this.disabled }, this.checked && (h("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("circle", { cx: "8", cy: "8", r: "2.5" }))))), this.format === 'right' && this.renderInfos())));
    }
    static get is() { return "core-radio-button"; }
    static get originalStyleUrls() {
        return {
            "$": ["core-radio-button.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["core-radio-button.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label that accompany the radio button. It is **required** for accessibility concerns."
                },
                "attribute": "label",
                "reflect": true
            },
            "description": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Description will append below the label."
                },
                "attribute": "description",
                "reflect": false
            },
            "format": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "'right' | 'left' | 'hidden'",
                    "resolved": "\"hidden\" | \"left\" | \"right\"",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "A string indicating the position of the label or if it is hidden."
                },
                "attribute": "format",
                "reflect": false,
                "defaultValue": "'right'"
            },
            "checked": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "A boolean indicating whether the radio is checked or unchecked."
                },
                "attribute": "checked",
                "reflect": true,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "A boolean indicating the disable state of the radio button. The `aria-disabled` attribute relies on this property."
                },
                "attribute": "disabled",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "coreRadioButtonChange",
                "name": "coreRadioButtonChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the checked value has changed."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=core-radio-button.js.map
